import { render, staticRenderFns } from "./AdminLingYu.vue?vue&type=template&id=38afec5a&scoped=true"
import script from "./AdminLingYu.vue?vue&type=script&lang=js"
export * from "./AdminLingYu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afec5a",
  null
  
)

export default component.exports